var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 76 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.216 41.747c3.133 1.958 3.133 6.521 0 8.48L7.65 91.206C4.32 93.286 0 90.893 0 86.966V5.008C0 1.081 4.32-1.313 7.65.768z"
  })));
};
export default SvgPlay;